const canvasCls = "_086c4hfe8x";

export { canvasCls };
import "./_tool.style.linaria.module.css";
//# sourceMappingURL=_tool.style.js.map
